import { JuloUpdateEntry } from "./types"

export const autoLevereradeLeveranserEntry: JuloUpdateEntry = {
  slug: "2026-05-13-auto-levererade-leveranser",
  date: "2026-05-13",
  title:
    "Öppna leveranser markeras automatiskt som levererade när ni markerar jobbet som färdigt eller utlämnat",
  description:
    "När ni markerar ett jobb som färdigt eller utlämnat markeras nu samtidigt alla öppna leveranser på jobbet (Att beställa och Väntar på del) som Levererade med dagens datum och med er som mottagare. Tidigare behövde ni gå in på varje leverans och markera den som mottagen för hand — nu sker det i samma steg som ni byter status på jobbet. Redan levererade leveranser rörs inte, så deras tidigare leveransdatum behålls. Det fungerar både när ni ändrar status på ett enskilt jobb och när ni gör en massuppdatering.",
}
